import React from 'react';
import { OfertaProduto } from '../Utils/ofertaProduto';
import './PrecoPromocional.css';
const dinheiro = (value: number) => `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const PrecoPromocional: React.FC<{ oferta: OfertaProduto; destaque?: boolean }> = ({ oferta, destaque }) => <span className={`preco-promocional${destaque ? ' preco-promocional-destaque' : ''}`}>
  <span className="preco-promocional-atual">{oferta.aPartirDe && <span className="preco-promocional-prefixo">A partir de </span>}{dinheiro(oferta.atual)}</span>
  <span className="preco-promocional-desconto"><del aria-label={`Preço original ${dinheiro(oferta.normal)}`}>{dinheiro(oferta.normal)}</del>
    {oferta.percentual > 0 && <span className="preco-promocional-selo" aria-label={`${oferta.percentual}% de desconto`}>-{oferta.percentual}%</span>}</span>
</span>;
export default PrecoPromocional;
